import { render } from "./MBPInput.vue?vue&type=template&id=1ec1bc6f&scoped=true"
import script from "./MBPInput.vue?vue&type=script&lang=js"
export * from "./MBPInput.vue?vue&type=script&lang=js"

import "./MBPInput.vue?vue&type=style&index=0&id=1ec1bc6f&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec1bc6f"]])

export default __exports__